import { type ForwardRefExoticComponent, forwardRef } from 'react';

import { GleamDot } from './gleam-dot';
import { GleamLabel } from './gleam-label';
import { GleamRoot } from './gleam-root';
import type { GleamPropsInterface } from './types/gleam.types';

/**
 * @since 7.39.0
 */

export const Gleam = forwardRef<HTMLSpanElement, GleamPropsInterface>(
  (props: GleamPropsInterface, forwardedRef) => {
    const { children, dotProps, appearance, ...rest } = props;
    const dotLabel = dotProps?.label;
    const dotVisualProps = {
      css: dotProps?.css,
      className: dotProps?.className,
    };

    return (
      <Gleam.Root>
        {children}
        <Gleam.Label
          ref={forwardedRef}
          appearance={appearance}
          countLabel={dotLabel}
          renderDot={
            appearance === 'dot'
              ? (inheritedDotProps) => <Gleam.Dot {...inheritedDotProps} {...dotVisualProps} />
              : undefined
          }
          {...rest}
        />
      </Gleam.Root>
    );
  },
) as ForwardRefExoticComponent<GleamPropsInterface> & {
  Root: typeof GleamRoot;
  Label: typeof GleamLabel;
  Dot: typeof GleamDot;
};

Gleam.displayName = 'Gleam';

Gleam.Root = GleamRoot;
Gleam.Label = GleamLabel;
Gleam.Dot = GleamDot;
